export default __webpack_public_path__ + "static/media/cw-ccw.edf0e3f8.png";